import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteClass(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteClass = (kiloClassTypeId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`kilo-classes/${kiloClassTypeId}/`);
  };

  return useMutation(deleteClass, {
    onSuccess: () => {
      queryClient.removeQueries('classes');
      queryClient.invalidateQueries('events');
      queryClient.invalidateQueries(['workouts', 'calendar']);
    },
  });
}
